import Geocode from "react-geocode";

export async function GeoCodeFromAddress(lookupAddress) {
  Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY);
  Geocode.enableDebug();
  const response = await Geocode.fromAddress(lookupAddress);
  return response.results[0].geometry.location;
}
